import React from 'react';

export const ButtonPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  
    const containerWidth = commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`;

    const containerStyle = {
      padding: `${commonAttrs.paddingTop}px ${commonAttrs.paddingRight}px ${commonAttrs.paddingBottom}px ${commonAttrs.paddingLeft}px`,
      margin: `${commonAttrs.marginTop}px ${commonAttrs.marginRight}px ${commonAttrs.marginBottom}px ${commonAttrs.marginLeft}px`,
      width: containerWidth,
      boxSizing: 'border-box',
      display: 'block'
    };

    const buttonWidth = commonAttrs?.width === 'auto' ? 'auto' : '100%';

    const btnStyle = {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: buttonWidth,
      maxWidth: '100%',
      padding: '16px',
      backgroundColor: specificAttrs.backgroundColor,
      color: specificAttrs.textColor,
      border: isSelected ? '2px solid #3B82F6' : 'none',
      borderRadius: `${specificAttrs.borderRadius}px`,
      fontSize: specificAttrs.size === 'small' ? '14px' : specificAttrs.size === 'large' ? '18px' : '16px',
      cursor: 'pointer',
      fontWeight: '500',
      boxSizing: 'border-box'
    };

    return (
      <div style={containerStyle}>
        <button style={btnStyle} onClick={onClick}>
          {specificAttrs.text || 'Button'}
        </button>
      </div>
    );
};
